import { useReducer } from 'react'
import { useOverlay } from '@fs/zion-ui'
import { getUser } from '@fs/zion-user'
import useNotifications from '../../../../hooks/useNotifications'
import * as queueService from '../../../../services/QueuesService'
import { deleteMessageById } from '../../../../services/dmqueuesService'

export default function useHolocaustDialog(
  message,
  personId,
  personName,
  onSubmitCallback,
  onCancelCallback,
  isHolocaust
) {
  const { error } = useNotifications()

  const initialState = {
    message,
    personId,
    personName,
    changeMessage: '',
    labelSelected: null,
    deleteMessage: true,
  }

  const reducer = (_, currentState) => {
    return { ...currentState }
  }

  const [holocaustDialogState, setHolocaustDialogState] = useReducer(reducer, initialState)
  const markHolocaustFunction = isHolocaust ? queueService.queueButtonHolocaust : queueService.queueButtonNotHolocaust
  const deleteResolution = `${isHolocaust ? 'Holocaust' : 'Not Holocaust'} - ${holocaustDialogState.labelSelected}`

  const holocaustDialogActions = {
    overlay: useOverlay(),
    setLabelSelected: (labelSelected) => {
      holocaustDialogState.labelSelected = labelSelected
      holocaustDialogActions.updateHolocaustDialogState()
    },
    setDeleteMessageSelected: (deleteMessageSelected) => {
      holocaustDialogState.deleteMessage = deleteMessageSelected
      holocaustDialogActions.updateHolocaustDialogState()
    },
    onOk: async () => {
      holocaustDialogActions.overlay.close()
      const user = await getUser()
      return markHolocaustFunction(
        personId,
        holocaustDialogState.labelSelected,
        user.cisId,
        holocaustDialogState.changeMessage
      ).then(() => {
        return OnOkCallback(
          message,
          personId,
          holocaustDialogActions.overlay,
          onSubmitCallback,
          error,
          holocaustDialogState.deleteMessage,
          deleteResolution
        )
      })
    },
    onCancel: () => {
      holocaustDialogActions.overlay.close()
      onCancelCallback?.()
    },
    setChangeMessage: (changeMessage) => {
      holocaustDialogState.changeMessage = changeMessage
      holocaustDialogActions.updateHolocaustDialogState()
    },
    updateHolocaustDialogState: () => {
      setHolocaustDialogState(holocaustDialogState)
    },
  }

  return { holocaustDialogState, holocaustDialogActions }
}

export function OnOkCallback(
  message,
  currentPersonId,
  overlay,
  onSubmitCallback,
  error,
  deleteMessage,
  deleteResolution
) {
  const messagePersonId = message.details.personId

  if (messagePersonId !== currentPersonId) {
    overlay.close()
    onSubmitCallback?.()
    return Promise.resolve()
  }

  if (deleteMessage) {
    return deleteMessageById(message.id, deleteResolution)
      .then(() => {
        overlay.close()
        onSubmitCallback?.()
        return Promise.resolve()
      })
      .catch((err) => {
        if (err.response.status === 404) {
          // it was deleted before so just ignore it
          overlay.close()
          onSubmitCallback?.()
        } else {
          error(`Failed to delete message ID: ${message.id}`, err)
        }
        return Promise.resolve() // I logged the message so just keep doing your stuff
      })
  }
  overlay.close()
  onSubmitCallback?.()
  return Promise.resolve()
}
